import { render, staticRenderFns } from "./TransactionsScrapping.vue?vue&type=template&id=231bde4d&"
import script from "./TransactionsScrapping.vue?vue&type=script&lang=js&"
export * from "./TransactionsScrapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports